/*!
 * Filename : index.tsx
 * Author: Achmad Yusri Afandi (yusrideb@cpan.org)
 * Date Create : 8/19/26 9:14 PM
 */

import React from 'react';
import {createRoot} from 'react-dom/client';

import App from './App';

const container = document.getElementById("app") as HTMLElement;
const root = createRoot(container);
root.render(<App/>);
